export const committees = (state) => state.committees.data;
